var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobMatchUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8211 37.7395C40.6211 37.7195 40.3811 37.7195 40.1611 37.7395C35.4011 37.5795 31.6211 33.6795 31.6211 28.8795C31.6211 23.9795 35.5811 19.9995 40.5011 19.9995C45.4011 19.9995 49.3811 23.9795 49.3811 28.8795C49.3611 33.6795 45.5811 37.5795 40.8211 37.7395Z",
    stroke: "#F04835",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8214 45.1205C25.9814 48.3605 25.9814 53.6405 30.8214 56.8605C36.3214 60.5405 45.3414 60.5405 50.8414 56.8605C55.6814 53.6205 55.6814 48.3405 50.8414 45.1205C45.3614 41.4605 36.3414 41.4605 30.8214 45.1205Z",
    stroke: "#F04835",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobMatchUser);
export default __webpack_public_path__ + "static/media/jobMatchUser.1538b1c41bdfdbddd303ae8d2ceaa0d4.svg";
export { ForwardRef as ReactComponent };